import { getPersonIdFromToken } from '@ibk/shared-auth';
import { selectAccessToken } from '@ibk/shared-config';
export function selectBenefitMigrationUserId(state) {
    const token = selectAccessToken(state);
    return token ? getPersonIdFromToken(token) : null;
}
